import { motion } from "framer-motion";
import { useT } from "@/lib/i18n";

export default function HowItWorks() {
  const t = useT();
  const STEPS = t.process.steps;
  return (
    <section id="process" data-testid="how-it-works" className="relative py-24 md:py-32 bg-[#111111] border-y border-[#2A2A2A]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-16 md:mb-24 max-w-2xl">
          <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] font-semibold mb-5">
            {t.process.eyebrow}
          </p>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#F5F5F0]">
            {t.process.titleA}
            <br />
            <span className="text-[#A3A3A3] italic font-normal">{t.process.titleB}</span>
          </h2>
        </div>

        <div className="divide-y divide-[#2A2A2A] border-y border-[#2A2A2A]">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              data-testid={`process-step-${s.n}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="grid grid-cols-12 gap-6 md:gap-12 py-10 md:py-14 group hover:bg-[#0A0A0A]/40 transition-colors px-3 md:px-6 -mx-3 md:-mx-6"
            >
              <div className="col-span-12 md:col-span-2">
                <div className="font-serif-display text-5xl md:text-6xl text-[#D4AF37] leading-none">{s.n}</div>
              </div>
              <div className="col-span-12 md:col-span-5">
                <h3 className="font-serif-display text-2xl md:text-3xl text-[#F5F5F0] leading-tight">
                  {s.title}
                </h3>
              </div>
              <div className="col-span-12 md:col-span-5">
                <p className="text-base md:text-lg text-[#A3A3A3] leading-relaxed">{s.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
